var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 58 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.275 32.4706H49.7417V48.7849C49.7417 51.6747 47.4168 54.0126 44.5137 54.0126H13.4748C10.585 54.0126 8.24694 51.6878 8.24694 48.7849V32.4706H4.71353C0.772913 32.4706 -1.88043 27.65 1.65298 24.0247L22.5645 2.73216C24.3378 0.880072 26.6627 0 29.0008 0C31.3389 0 33.6639 0.880072 35.516 2.73216L40.258 7.55286V3.29699C40.258 1.44489 41.7817 0 43.6338 0H46.4446C48.2179 0 49.7417 1.44489 49.7417 3.29699V17.2862L56.3355 24.0378C59.856 27.65 57.2946 32.4706 53.275 32.4706Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.6ea3e1101b604f686b0bb8b538fd80f9.svg";
export { ForwardRef as ReactComponent };